import { useNavigate } from 'react-router-dom';
import { SVGIcon } from '@omnipkg/ui-kit-web';

import FlowManager from '@src/components/FlowManager';
import { FeedbackPath } from '@src/types/routes';

import { useOnConfirm } from './hooks/useOnConfirm';

import { ButtonWrapper, RateButtonsWrapper, RateTitle } from './styled';

export default function Feedback(): JSX.Element {
  const navigate = useNavigate();

  const { isPending, onConfirm } = useOnConfirm();

  const goToLikeRate = () => onConfirm();

  const goToDislikeRate = () => navigate(FeedbackPath.Dislike);

  return (
    <FlowManager title="Your shipment is accepted for delivery">
      <RateButtonsWrapper>
        <RateTitle>Please, rate the quality of our service</RateTitle>
        <ButtonWrapper
          type="button"
          aria-label="Tap this if you like our service"
          onClick={goToLikeRate}
          disabled={isPending}
        >
          <SVGIcon name="like-face" fillVariant="primary" size={100} />
        </ButtonWrapper>
        <ButtonWrapper
          type="button"
          aria-label="Tap this if you dislike our service"
          onClick={goToDislikeRate}
          disabled={isPending}
        >
          <SVGIcon name="dislike-face" fillVariant="error" size={100} />
        </ButtonWrapper>
      </RateButtonsWrapper>
    </FlowManager>
  );
}
